import { Result } from "antd";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import s from "./ForbiddenPage.module.scss";

export function ForbiddenPage(): ReactElement {
  const { t } = useTranslation();
  return <Result
    className={s.container}
    status="403"
    title={t("forbiddenpage.title")}
    subTitle={t("forbiddenpage.subTitle")}
  />
}
